// const BackendUrl = 'http://localhost:8080';
const BackendUrl = 'https://admin.teegeeagency.lk/api';
// Export the API URL so it can be imported elsewhere
export default BackendUrl;